import firebase from "../services/firebase";
import { useStore } from "../stores";
import { useMessageFiles } from "./useMessageFiles";

const bucket = (firebase.options as { storageBucket?: string }).storageBucket || "";

/** Reuses expiring grants without changing the URLs saved in Firestore. */
export function useSharedFiles<T>(data: T) {
  const { selectedBot } = useStore("bots");
  const { selectedWorkspace } = useStore("workspaces");
  const bot = selectedBot || selectedWorkspace?.functions?.find(f => f.meta?.bot?.id)?.meta?.bot;

  return useMessageFiles(data, {
    botId: Number(bot?.id) || 0,
    key: bot?.key || "",
    password: bot?.password || "",
    bucket,
    shared: true,
  });
}
